'use strict';

const CONFIG = {
    min_zoom: 2
};

/*
const ICON_MAPPING = {
    "open_diamond": "https://maps.google.com/mapfiles/kml/shapes/open-diamond.png",
    "mountains": "https://maps.google.com/mapfiles/kml/shapes/mountains.png",
    "sea_ports": "https://maps.google.com/mapfiles/kml/shapes/sea_ports.png",
    "ranger_station": "https://maps.google.com/mapfiles/kml/shapes/ranger_station.png",
    "purple_blank": "https://maps.google.com/mapfiles/kml/paddle/purple-blank.png",
    "boat_launch": "https://maps.google.com/mapfiles/kml/shapes/boat_launch.png",
    "orange_stars": "https://maps.google.com/mapfiles/kml/paddle/orange-stars.png",
    "museum": "https://maps.google.com/mapfiles/kml/shapes/museum.png",
    "blu_blank": "https://maps.google.com/mapfiles/kml/paddle/blu-blank.png",
    "triangle": "https://maps.google.com/mapfiles/kml/shapes/triangle.png",
    "hindu_temple": "https://maps.google.com/mapfiles/kml/shapes/hindu_temple.png",
    "red_blank": "https://maps.google.com/mapfiles/kml/paddle/red-blank.png",
    "terrain": "https://maps.google.com/mapfiles/kml/shapes/terrain.png",
    "lighthouse": "https://maps.google.com/mapfiles/kml/shapes/lighthouse.png",
    "landmark": "https://maps.google.com/mapfiles/kml/shapes/landmark.png",
    "wht_stars": "https://maps.google.com/mapfiles/kml/paddle/wht-stars.png",
    "ltblu_blank": "https://maps.google.com/mapfiles/kml/paddle/ltblu-blank.png",
    "stable": "https://maps.google.com/mapfiles/kml/shapes/stable.png",
    "capital_big": "https://maps.google.com/mapfiles/kml/shapes/capital_big.png",
    "capital_big_highlight": "https://maps.google.com/mapfiles/kml/shapes/capital_big_highlight.png",
    "ranger_tower": "https://maps.google.com/mapfiles/kml/shapes/ranger_tower.png",
    "schools": "https://maps.google.com/mapfiles/kml/shapes/schools.png",
    "ylw_diamond": "https://maps.google.com/mapfiles/kml/paddle/ylw-diamond.png",
    "pink_blank": "https://maps.google.com/mapfiles/kml/paddle/pink-blank.png",
    "capital_small": "https://maps.google.com/mapfiles/kml/shapes/capital_small.png",
    "donut": "https://maps.google.com/mapfiles/kml/shapes/donut.png",
    "grn_square": "https://maps.google.com/mapfiles/kml/paddle/grn-square.png",
    "parks": "https://maps.google.com/mapfiles/kml/shapes/parks.png",
    "cemetary_jp": "https://maps.google.com/mapfiles/kml/shapes/cemetary_jp.png",
    "govtbldgs": "https://maps.google.com/mapfiles/kml/shapes/govtbldgs.png",
    "ylw_blank": "https://maps.google.com/mapfiles/kml/paddle/ylw-blank.png",
    "w_blue": "https://maps.google.com/mapfiles/kml/paddle/W_blue.png",
    "square": "https://maps.google.com/mapfiles/kml/shapes/square.png",
    "orange_blank": "https://maps.google.com/mapfiles/kml/paddle/orange-blank.png",
    "shaded_dot": "https://maps.google.com/mapfiles/kml/shapes/shaded_dot.png",
    "wht_blank": "https://maps.google.com/mapfiles/kml/paddle/wht-blank.png",
    "grn_blank": "https://maps.google.com/mapfiles/kml/paddle/grn-blank.png",
    "ylw_stars": "https://maps.google.com/mapfiles/kml/paddle/ylw-stars.png",
    "measle_turquoise": "https://maps.google.com/mapfiles/kml/shapes/placemark_circle.png",
    "m": "https://maps.google.com/mapfiles/kml/paddle/M.png"
};
*/



export let globalInfoWindow;

export function createGeoJsonLayer(url) {

    class GeoJsonLayer extends google.maps.MVCObject {

        constructor() {
            super();
            this.setValues({map: null});

            this.features = undefined;
            this.filterFunc = () => false;
            this.autoCompleteList = [];
            this.mapObjects = [];

            this.load();
        }

        getBounds() {
            const mapBounds = new google.maps.LatLngBounds();

            let minLat = 9999;
            let maxLat = -9999;
            let minLng = 9999;
            let maxLng = -9999;

            if (!this.features) return;

            const features = this.features.filter(this.filterFunc);

            features.forEach((feature) => {
                if (!feature.geometry) return;
                if (!feature.properties) return;

                switch (feature.geometry.type) {
                    case 'Point':
                        const coordinates = feature.geometry.coordinates;
                        mapBounds.extend(new google.maps.LatLng(coordinates[1], coordinates[0]));
                        break;
                    case 'Polygon':
                        feature.geometry.coordinates[0].forEach(row => {
                            if (minLng > row[0]) minLng = row[0];
                            if (maxLng < row[0]) maxLng = row[0];
                            if (minLat > row[1]) minLat = row[1];
                            if (maxLat < row[1]) maxLat = row[1];
                        });

                }
                
            });

            if (minLat < 9999) {
                mapBounds.extend(new google.maps.LatLng(minLat, minLng));
                mapBounds.extend(new google.maps.LatLng(maxLat, maxLng));
            }

            return mapBounds;
        }

        refresh() {
            this.mapObjects.forEach(mapObject => {
                mapObject.setMap(null);
            });
            this.mapObjects = [];

            const features = this.features.filter(this.filterFunc);
            
            features.forEach((feature) => {
                if (!feature.geometry) return;
                if (!feature.properties) return;

                const properties = feature.properties;

                const infowindow = new google.maps.InfoWindow({
                    content: properties.description
                });

                switch (feature.geometry.type) {
                    case 'Point':
    
                        // if (!properties.icon) break;
                       
                        //const url = ICON_MAPPING[properties.tipoicon] ? ICON_MAPPING[properties.tipoicon] : 'https://maps.google.com/mapfiles/kml/shapes/'+properties.tipoicon+'.png';
                        const image = {
	                        
	                        scaledSize: new google.maps.Size(20, 20),
                            url: properties.icon ? properties.icon : url
                        };
                        
                        const coordinates = feature.geometry.coordinates;
                        const marker = new google.maps.Marker({
                            position: new google.maps.LatLng(coordinates[1], coordinates[0]),
                            title: properties.name,
                            icon: image,
                            size: new google.maps.Size(20, 20)
                            //size: new google.maps.Size(54, 54)
                        });
    
                        marker.addListener('click', () => {
                            if (globalInfoWindow) {
                                globalInfoWindow.close();
                                globalInfoWindow = null;
                            }
                            infowindow.open(this.get('map'), marker);
                            globalInfoWindow = infowindow;
                        });
    
                        marker.setMap(this.get('map'));
                        this.mapObjects.push(marker);

                        break;
                        
                    case 'Polygon':
                        const polygonCoordinates = feature.geometry.coordinates[0].map(row => ({lat: row[1], lng: row[0]}));
                        
                        const polygon = new google.maps.Polygon({
                            paths: polygonCoordinates,
                            strokeColor: properties['stroke'],
                            strokeOpacity: properties['stroke-opacity'],
                            strokeWeight: properties['stoke-width'],
                            fillColor: properties['fill'],
                            fillOpacity: properties['fill-opacity']
                        });

                        polygon.addListener('click', () => {
                            if (globalInfoWindow) {
                                globalInfoWindow.close();
                                globalInfoWindow = null;
                            }

                            const bounds = new google.maps.LatLngBounds();
                            polygon.getPath().forEach(element => {bounds.extend(element)});
                            infowindow.setPosition(bounds.getCenter());
                            infowindow.open(this.get('map'), polygon);
                            globalInfoWindow = infowindow;
                        });

                        polygon.setMap(this.get('map'));
                        this.mapObjects.push(polygon);

                        break;
                        
                    default:
                        console.error('Unknown Geometry: ', feature.geometry.type, feature.geometry);
                }
            });
        }

        createAutoComplete() {
            const hashMap = this.features.reduce( (accumulator, currentFeature) => {
                if (!currentFeature.properties) return;
                if (!currentFeature.properties.name) return;
                
                if (!accumulator[currentFeature.properties.name]) {
                    accumulator[currentFeature.properties.name] = 0;
                }
                accumulator[currentFeature.properties.name]++;
                
                return accumulator;
            }, {});


            this.autoCompleteList = Object.keys(hashMap);
        }
        
        setFilter(filter) {
            if (filter) {
                this.filterFunc = filter;
            } else {
                this.filterFunc = () => false;
            }
            this.refresh();
        }
        
        async load() {
            const response = await fetch(url);
            const json = await response.json();

            this.features = json.features;
            
            this.createAutoComplete();

            this.refresh();

            google.maps.event.trigger(this, 'loaded');
        }
        
        setMap(map) {
            this.set('map', map);
        }
    }
    
    return new GeoJsonLayer(url);
}


export function createGeoJsonLayerSky(url) {

    class GeoJsonLayer extends google.maps.MVCObject {

        constructor() {
            super();
            this.setValues({map: null});

            this.features = undefined;
            this.filterFunc = () => false;
            this.autoCompleteList = [];
            this.mapObjects = [];

            this.load();
        }

        getBounds() {
            const mapBounds = new google.maps.LatLngBounds();

            let minLat = 9999;
            let maxLat = -9999;
            let minLng = 9999;
            let maxLng = -9999;

            if (!this.features) return;

            const features = this.features.filter(this.filterFunc);

            features.forEach((feature) => {
                if (!feature.geometry) return;
                if (!feature.properties) return;

                switch (feature.geometry.type) {
                    case 'Point':
                        const coordinates = feature.geometry.coordinates;
                        mapBounds.extend(new google.maps.LatLng(coordinates[1], coordinates[0]));
                        break;
                    case 'Polygon':
                        feature.geometry.coordinates[0].forEach(row => {
                            if (minLng > row[0]) minLng = row[0];
                            if (maxLng < row[0]) maxLng = row[0];
                            if (minLat > row[1]) minLat = row[1];
                            if (maxLat < row[1]) maxLat = row[1];
                        });

                }
                
            });

            if (minLat < 9999) {
                mapBounds.extend(new google.maps.LatLng(minLat, minLng));
                mapBounds.extend(new google.maps.LatLng(maxLat, maxLng));
            }

            return mapBounds;
        }

        refresh() {
            this.mapObjects.forEach(mapObject => {
                mapObject.setMap(null);
            });
            this.mapObjects = [];

            const features = this.features.filter(this.filterFunc);
            
            features.forEach((feature) => {
                if (!feature.geometry) return;
                if (!feature.properties) return;

                const properties = feature.properties;

                const infowindow = new google.maps.InfoWindow({
                    content: properties.description
                });

                switch (feature.geometry.type) {
                    case 'Point':
    
                        // if (!properties.icon) break;
                       
                        //const url = ICON_MAPPING[properties.tipoicon] ? ICON_MAPPING[properties.tipoicon] : 'https://maps.google.com/mapfiles/kml/shapes/'+properties.tipoicon+'.png';
                        const image = {
	                        
	                        scaledSize: new google.maps.Size(40, 40),
                            url: properties.icon ? properties.icon : url
                        };
                        
                        const coordinates = feature.geometry.coordinates;
                        const marker = new google.maps.Marker({
                            position: new google.maps.LatLng(coordinates[1], coordinates[0]),
                            title: properties.name,
                            icon: image,
                            size: new google.maps.Size(40, 40)
                            //size: new google.maps.Size(54, 54)
                        });
    
                        marker.addListener('click', () => {
                            if (globalInfoWindow) {
                                globalInfoWindow.close();
                                globalInfoWindow = null;
                            }
                            infowindow.open(this.get('map'), marker);
                            globalInfoWindow = infowindow;
                        });
    
                        marker.setMap(this.get('map'));
                        this.mapObjects.push(marker);

                        break;
                        
                    case 'Polygon':
                        const polygonCoordinates = feature.geometry.coordinates[0].map(row => ({lat: row[1], lng: row[0]}));
                        
                        const polygon = new google.maps.Polygon({
                            paths: polygonCoordinates,
                            strokeColor: properties['stroke'],
                            strokeOpacity: properties['stroke-opacity'],
                            strokeWeight: properties['stoke-width'],
                            fillColor: properties['fill'],
                            fillOpacity: properties['fill-opacity']
                        });

                        polygon.addListener('click', () => {
                            if (globalInfoWindow) {
                                globalInfoWindow.close();
                                globalInfoWindow = null;
                            }

                            const bounds = new google.maps.LatLngBounds();
                            polygon.getPath().forEach(element => {bounds.extend(element)});
                            infowindow.setPosition(bounds.getCenter());
                            infowindow.open(this.get('map'), polygon);
                            globalInfoWindow = infowindow;
                        });

                        polygon.setMap(this.get('map'));
                        this.mapObjects.push(polygon);

                        break;
                        
                    default:
                        console.error('Unknown Geometry: ', feature.geometry.type, feature.geometry);
                }
            });
        }

        createAutoComplete() {
            const hashMap = this.features.reduce( (accumulator, currentFeature) => {
                if (!currentFeature.properties) return;
                if (!currentFeature.properties.name) return;
                
                if (!accumulator[currentFeature.properties.name]) {
                    accumulator[currentFeature.properties.name] = 0;
                }
                accumulator[currentFeature.properties.name]++;
                
                return accumulator;
            }, {});


            this.autoCompleteList = Object.keys(hashMap);
        }
        
        setFilter(filter) {
            if (filter) {
                this.filterFunc = filter;
            } else {
                this.filterFunc = () => false;
            }
            this.refresh();
        }
        
        async load() {
            const response = await fetch(url);
            const json = await response.json();

            this.features = json.features;
            
            this.createAutoComplete();

            this.refresh();

            google.maps.event.trigger(this, 'loaded');
        }
        
        setMap(map) {
            this.set('map', map);
        }
    }
    
    return new GeoJsonLayer(url);
}
